import React, {useState, useEffect} from 'react';
import {Box} from '@chakra-ui/react';
import {keyframes} from '@emotion/react';
import Icon from '../Icon';

const bookmarkPop = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.15); }
  100% { transform: scale(1); }
`;

interface BookmarkButtonProps {
  isBookmarked: boolean;
  onClick: (e: React.MouseEvent) => void;
  size?: string;
  iconSize?: string;
  [key: string]: any; // Allow additional props like position, top, right, etc.
}

const BookmarkButton: React.FC<BookmarkButtonProps> = ({
  isBookmarked,
  onClick,
  size = '32px',
  iconSize = '10px',
  ...props
}) => {
  const [shouldPop, setShouldPop] = useState(false);

  useEffect(() => {
    if (isBookmarked) {
      setShouldPop(true);
      const timer = setTimeout(() => setShouldPop(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isBookmarked]);

  return (
    <Box
      w={size}
      h={size}
      bg={isBookmarked ? '#C9136B' : 'white'}
      border="2px solid #F4CFE2"
      borderRadius="full"
      display="flex"
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
      boxShadow={
        isBookmarked ? '0px 3px 8px rgba(201, 19, 107, 0.2)' : '0px 2px 8px rgba(0, 0, 0, 0.1)'
      }
      onClick={onClick}
      zIndex={2}
      transition="background-color 0.2s ease-in-out, border 0.2s ease-in-out, box-shadow 0.2s ease-in-out, transform 0.1s ease-out"
      _active={{transform: 'scale(0.9)'}}
      animation={shouldPop ? `${bookmarkPop} 0.3s ease-out` : 'none'}
      {...props}>
      <Icon
        iconName={isBookmarked ? 'fi-br-check' : 'fi-br-plus'}
        style={{
          transition: 'color 0.2s ease-in-out',
          fontSize: iconSize,
          color: isBookmarked ? 'white' : '#262626',
        }}
      />
    </Box>
  );
};

export default BookmarkButton;
